module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-error-802000ba7bd7f8e01a81b81ee03976bd.svg";